<template>
  <div class="mt-5 mb-5">
    <div class="content-form-examen mb-5">
      <div class="row p-3">
        <div class="col-md-4">
          <Date
            label="Fecha"
            name="made_at"
            :value="formData.made_at"
            :required="true"
            :disabled="isDisabled"
            v-model="formData.made_at"
          />
        </div>
        <div class="col-md-4">
          <Select
            label="Ciudad"
            name="made_in"
            :options="cities"
            :value="formData.made_in"
            :required="true"
            :disabled="isDisabled"
            v-model="formData.made_in"
          />
        </div>
        <div class="col-md-4">
          <Input
            label="Persona quién elabora la inspección"
            name="made_by"
            :value="formData.made_by"
            :required="true"
            :disabled="isDisabled"
            @input="(event) => (formData.made_by = event.target.value)"
          />
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12">
        <InformationEmployee :employee="employee" />
      </div>
    </div>
    <form @submit.prevent="saveData()">
      <div class="content-form-examen mb-5">
        <div class="header">Información adicional</div>
        <div class="row mt-5">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12 mb-4">
                <Date
                  label="Fecha de ingreso a la empresa"
                  name="seniority_company"
                  :value="formData.seniority_company"
                  :required="true"
                  :disabled="isDisabled"
                  v-model="formData.seniority_company"
                />
              </div>
              <div class="col-md-12" v-if="formData.seniority_company">
                <Input
                  label="Antiguedad en la empresa"
                  name="seniority_company_format"
                  :value="calcularTiempo(formData.seniority_company)"
                  :required="false"
                  :disabled="true"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12 mb-4">
                <Date
                  label="Fecha de ingreso al cargo"
                  name="seniority_position"
                  :value="formData.seniority_position"
                  :required="true"
                  :disabled="isDisabled"
                  v-model="formData.seniority_position"
                />
              </div>
              <div class="col-md-12" v-if="formData.seniority_position">
                <Input
                  label="Antiguedad en el cargo"
                  name="seniority_position_format"
                  :value="calcularTiempo(formData.seniority_position)"
                  :required="false"
                  :disabled="true"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <Input
              label="Turno"
              name="turn"
              :value="formData.turn"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.turn = event.target.value)"
            />
          </div>
        </div>
        <hr class="hr-form-ipt" />
        <div class="row mt-5">
          <div class="col-md-4 mb-4">
            <Select
              label="Predominancia"
              name="predominance"
              :options="typePredominance"
              :value="formData.predominance"
              :disabled="isDisabled"
              v-model="formData.predominance"
            />
          </div>
          <div class="col-md-4 mb-4">
            <Select
              label="Tipo de cargo"
              name="position_type"
              :options="typePosition"
              :value="formData.position_type"
              :disabled="isDisabled"
              v-model="formData.position_type"
            />
          </div>
          <div class="col-md-4 mb-4">
            <Select
              label="Talla"
              name="size"
              :options="sizes"
              :value="formData.size"
              :disabled="isDisabled"
              v-model="formData.size"
            />
          </div>
          <div class="col-md-4">
            <Input
              label="Peso en kilogramos"
              name="weight"
              :value="formData.weight"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.weight = event.target.value)"
            />
          </div>
          <div class="col-md-4">
            <Input
              label="Indice de masa corporal"
              name="corporal_index"
              :value="formData.corporal_index"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.corporal_index = event.target.value)"
            />
          </div>
          <div class="col-md-4">
            <Input
              label="Interpretación"
              name="interpretation"
              :value="formData.interpretation"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.interpretation = event.target.value)"
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Detalles adicionales</div>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card-form-survey">
              <div class="d-flex align-items-center">
                <img
                  src="@/assets/images/icons/icon-morbidity/icon3.png"
                  alt=""
                  class="mr-3"
                />
                <h3>Hábitos</h3>
              </div>
              <div class="mt-4">
                <p class="title-form-survey">Fuma <strong>*</strong></p>
                <input-check-box
                  :options="options"
                  :id="1"
                  :isBusy="isBusy"
                  :isDetail="isDisabled"
                  :answer="formData.smoke?.value"
                  @answerQuestion="(value) => (formData.smoke = value)"
                />
              </div>
              <hr class="hr-form-ipt" />
              <div class="">
                <p class="title-form-survey">
                  Realiza usted algún tipo de actividad física?
                  <strong>*</strong>
                </p>
                <input-check-box
                  :options="options"
                  :id="2"
                  :isBusy="isBusy"
                  :isDetail="isDisabled"
                  :answer="formData.physical_activity?.value"
                  @answerQuestion="
                    (value) => (formData.physical_activity = value)
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card-form-survey">
              <div class="d-flex align-items-center">
                <img
                  src="@/assets/images/icons/icon-morbidity/icon2.png"
                  alt=""
                  class="mr-3"
                />
                <h3>Estado actual de salud osteomuscular</h3>
              </div>
              <div class="mt-4">
                <p class="title-form-survey">
                  ¿Presenta dolor, molestias o disconfort a nivel osteomuscular
                  en alguna parte del cuerpo? <strong>*</strong>
                </p>
                <input-check-box
                  :options="options"
                  :id="3"
                  :isBusy="isBusy"
                  :isDetail="isDisabled"
                  :answer="formData.pain_of_body?.value"
                  @answerQuestion="(value) => (formData.pain_of_body = value)"
                />
              </div>
              <hr class="hr-form-ipt" />
              <div class="">
                <p class="title-form-survey">
                  ¿Presenta alguna enfermedad osteomuscular actualmente?<strong
                    >*</strong
                  >
                </p>
                <input-check-box
                  :options="options"
                  :id="4"
                  :isBusy="isBusy"
                  :isDetail="isDisabled"
                  :answer="formData.musculoskeletal_disease?.value"
                  @answerQuestion="
                    (value) => (formData.musculoskeletal_disease = value)
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Segmento corporal</div>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card-form-survey-2">
              <div class="d-flex">
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/icon-morbidity/icon1.png"
                    alt=""
                  />
                </div>
                <div>
                  <p>
                    Seleccione la <strong>casilla correspondiente</strong> de
                    los numerales
                    <strong
                      >del 0 al 24 o seleccione la parte del cuerpo en el
                      gráfico</strong
                    >, indicando si ha presentado
                    <strong
                      >MOLESTIA o DOLOR en los últimos doce (12) meses</strong
                    >
                    en alguno o algunos de los
                    <strong>segmentos de su cuerpo</strong> de la siguiente
                    manera:
                  </p>
                  <p>Frecuencia:</p>
                  <div>
                    <ul>
                      <li><strong>Nunca:</strong> Cuando no se presente</li>
                      <li>
                        <strong>Rara vez:</strong> Si se presenta una vez por
                        mes
                      </li>
                      <li>
                        <strong>Frecuente:</strong> Si se presenta por lo menos
                        una vez cada dos (2) semanas
                      </li>
                      <li>
                        <strong>Continuo:</strong> Si se presenta a diaria o más
                        de tres (3) veces por semana
                      </li>
                    </ul>
                  </div>
                  <p>
                    Si marcó en la frecuencia
                    <strong>RARA VEZ, FRECUENTE O CONTINUO</strong>, califique
                    la <strong>SEVERIDAD</strong> de la molestia o el
                    <strong>dolor según sea el caso</strong> en:
                  </p>
                  <div class="mb-3">
                    <img
                      src="@/assets/images/icons/icon-morbidity/circle1.png"
                      alt=""
                    />
                    Leve
                  </div>
                  <div class="mb-3">
                    <img
                      src="@/assets/images/icons/icon-morbidity/circle2.png"
                      alt=""
                    />
                    Moderado
                  </div>
                  <div class="mb-3">
                    <img
                      src="@/assets/images/icons/icon-morbidity/circle3.png"
                      alt=""
                    />
                    Severo
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card-form-survey-alert">
              <div class="d-flex">
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/icon-morbidity/icon1.png"
                    alt=""
                  />
                </div>
                <div>
                  <p>
                    Selecciona el segmento corporal haciendo clic en los
                    numerales de la izquierda o haciendo clic en la figura.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="row mt-5">
          <div class="col-md-6">
            <div class="card-list-body-survey">
              <b-overlay :show="isLoadingBodyParts" rounded="sm">
                <template #overlay>
                  <OverlayButton clase="overlay-md"> </OverlayButton>
                </template>
                <div
                  class="content-item mb-4"
                  v-for="item in bodyParts"
                  :key="item.id"
                >
                  <span
                    ><strong>{{ item.code }}.</strong> {{ item.name }}</span
                  >
                  <button
                    type="button"
                    @click.prevent="addBodyParts(item)"
                    v-if="!item?.isAdd && !record"
                  >
                    Agregar
                    <img
                      src="@/assets/images/icons/icon-morbidity/icon4.png"
                      alt=""
                    />
                  </button>
                  <button type="button" class="active" v-else-if="item?.isAdd">
                    Agregado
                    <img
                      src="@/assets/images/icons/icon-morbidity/icon11.png"
                      alt=""
                    />
                  </button>
                </div>
              </b-overlay>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex align-items-center justify-content-center">
              <b-overlay :show="isLoadingBodyParts" rounded="sm">
                <template #overlay>
                  <OverlayButton clase="overlay-md"> </OverlayButton>
                </template>
                <div style="width: 320px">
                  <BodyPart @selectPart="(value) => selectPart(value)" />
                </div>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-if="!isDisabled">
        <div class="col-md-12">
          <p>
            No podrá avanzar en el guardado de la encuesta sin el check del
            paciente ya sea confirmado por
            <strong
              >correo electrónico electronico o adjuntando formato con
              firma.</strong
            >
          </p>
        </div>
      </div>
      <div class="row mt-5" v-if="!isDisabled">
        <div class="col-md-12">
          <div class="d-flex justify-content-start content-buttons-survey">
            <button
              type="button"
              class="mr-5"
              :disabled="!formData.made_by ? true : false"
              @click.prevent="sendEmail()"
            >
              Correo electrónico
              <img
                src="@/assets/images/icons/icon-morbidity/icon5.png"
                alt=""
              />
            </button>
            <button
              type="button"
              class="mr-5"
              :disabled="!formData.made_by ? true : false"
              @click.prevent="$bvModal.show('modal-confirm-upload-file')"
            >
              Adjuntar autorización firmada
              <img
                src="@/assets/images/icons/icon-morbidity/icon8.png"
                alt=""
              />
            </button>
            <button
              type="button"
              :disabled="!formData.made_by ? true : false"
              @click.prevent="downloadAuthorization()"
            >
              Descargar autorización
              <img
                src="@/assets/images/icons/icon-morbidity/icon6.png"
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-if="!isDisabled">
        <div class="col-md-12">
          <p>
            <strong
              >Si ya completaste todos los datos, por favor registra el formato
              de sintomatología</strong
            >
          </p>
        </div>
      </div>
      <div class="row mt-5 mb-5" v-if="isDisabled">
        <div class="col-md-12">
          <p>
            <strong
              >Autorización por {{ record?.authorization?.authorized_with === "file" ? "Documento firmando" : "Correo electrónico" }}</strong
            >
          </p>
        </div>
        <div class="col-md-4">
          <Input
            label="Fecha de autorización"
            name="authorized_at"
            :value="record?.authorization?.authorized_at"
            :disabled="true"
          />
        </div>
        <div class="col-md-4" v-if="record?.authorization?.authorized_with !== 'file'">
          <Input
            label="Correo electrónico"
            name="email"
            :value="record?.authorization?.email"
            :disabled="true"
          />
        </div>
        <div class="col-md-12 mt-3" v-if="record?.authorization?.authorized_with == 'file'">
            <div class="d-flex justify-content-between">
              <a
                :href="record?.authorization?.file"
                class="download-template-pdf"
                target="_blank"
              >
                Descargar autorización firmada
              </a>
            </div>
          </div>
      </div>
      <div class="d-flex justify-content-center mb-4" v-if="!isDisabled">
        <button
          class="button_primary"
          type="submit"
          :disabled="
            isBusy || $v.$invalid || (!identifierEmail && !identifierFile)
          "
        >
          <b-spinner v-if="isBusy" />
          Registrar sintomatología
        </button>
      </div>
    </form>
    <ModalAddBodyPart
      :levels="levels"
      :frecuencies="frecuencies"
      @addBodyPartsConfirm="(values) => addBodyPartsConfirm(values)"
    />
    <ModalRequestConfirmEmail
      v-if="employee"
      :employee="employee"
      :doctor_name="formData.made_by"
      @sendEmailSuccess="sendEmailSuccess"
    />
    <ModalAwaitConfirmEmail v-if="employee" :employee="employee" />
    <ModalSuccessConfirmEmail />
    <ModalConfirmUploadFile
      @successFileAuthorization="successFileAuthorization"
    />
    <ModalSuccessMorbidity />
  </div>
</template>

<script>
import {
  getEmployee,
  saveMorbidity,
  getAllBodyParts,
  getCities,
  verifyAuthorization,
} from "@/services/health-tracker/saludCondition/service";
import { getInfoSelect } from "@/services/health-tracker/diagnostic/service";
import useInputs from "@/components/general/Inputs";
const { Input, Textarea, Select, Date } = useInputs();
const { required } = require("vuelidate/lib/validators");
import UploadFilePhoto from "../UploadFilePhoto.vue";
import InformationEmployee from "../../../matrizIper/components/InformationEmployee.vue";
import InputCheckBox from "../../../components/formIpt/InputCheckBox.vue";
import ModalAddBodyPart from "../modals/ModalAddBodyPart.vue";
import ModalRequestConfirmEmail from "../modals/ModalRequestConfirmEmail.vue";
import ModalAwaitConfirmEmail from "../modals/ModalAwaitConfirmEmail.vue";
import ModalSuccessConfirmEmail from "../modals/ModalSuccessConfirmEmail.vue";
import ModalConfirmUploadFile from "../modals/ModalConfirmUploadFile.vue";
import ModalSuccessMorbidity from "../modals/ModalSuccessMorbidity.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import BodyPart from "../BodyPart.vue";
export default {
  components: {
    UploadFilePhoto,
    Input,
    Textarea,
    Select,
    Date,
    InformationEmployee,
    InputCheckBox,
    ModalAddBodyPart,
    ModalRequestConfirmEmail,
    ModalAwaitConfirmEmail,
    ModalSuccessConfirmEmail,
    ModalConfirmUploadFile,
    ModalSuccessMorbidity,
    OverlayButton,
    BodyPart,
  },
  props: {
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    const me = this;
    return {
      formData: {
        seniority_company: "",
        seniority_position: "",
        turn: "",
        predominance: null,
        position_type: null,
        size: null,
        weight: "",
        corporal_index: "",
        interpretation: "",
        smoke: null,
        physical_activity: null,
        pain_of_body: null,
        musculoskeletal_disease: null,
        employee_id: null,
        body_parts: [],
        made_at: "",
        made_in: null,
        made_by: null,
      },
      employee: null,
      options: [
        { text: "Si", value: "1" },
        { text: "No", value: "0" },
      ],
      id: me.$route.params.id,
      type: me.$route.params.type,
      category: me.$route.params.category,
      isBusy: false,
      isLoadingBodyParts: false,
      bodyParts: [],
      sizes: [
        {
          id: "size_s",
          name: "S",
        },
        {
          id: "size_m",
          name: "M",
        },
        {
          id: "size_l",
          name: "L",
        },
      ],
      typePredominance: [
        {
          id: "left",
          name: "Izquierda",
        },
        {
          id: "right",
          name: "Derecha",
        },
      ],
      typePosition: [
        {
          id: "terminal_video",
          name: "Video terminales (VDT)",
        },
        {
          id: "operative",
          name: "Operativo",
        },
      ],
      frecuencies: [],
      levels: [],
      cities: [],
      itemBodyPart: null,
      seniority_company_format: "",
      seniority_position_format: "",
      identifierEmail: null,
      identifierFile: null,
    };
  },
  watch: {
    record() {
      const me = this;
      if (me.record) {
        const predominance = me.typePredominance.find(
          (x) => x.id == me.record.predominance
        );
        const positionType = me.typePosition.find(
          (x) => x.id == me.record.position_type
        );
        const size = me.sizes.find((x) => x.id == me.record.size);
        const option1 = { text: "Si", value: "1" };
        const option2 = { text: "No", value: "0" };

        me.formData = {
          seniority_company: me.record?.seniority_company,
          seniority_position: me.record?.seniority_position,
          turn: me.record?.turn,
          weight: me.record?.weight,
          corporal_index: me.record?.corporal_index,
          interpretation: me.record?.interpretation,
          made_at: me.record?.made_at,
          made_in: me.record?.city,
          made_by: me.record?.made_by,
          smoke: me.record?.smoke ? option1 : option2,
          physical_activity: me.record?.physical_activity ? option1 : option2,
          pain_of_body: me.record?.pain_of_body ? option1 : option2,
          musculoskeletal_disease: me.record?.musculoskeletal_disease
            ? option1
            : option2,
          predominance: predominance || null,
          position_type: positionType || null,
          size: size || null,
          body_parts: [],
          employee_id: null,
        };

        // body_parts: me.record?.body_parts,
        me.record?.body_parts.forEach((item) => {
          me.formData.body_parts.push({
            body_part_id: item?.evaluation?.body_part_id,
            frequency_id: item?.evaluation?.frequency_id,
            level_id: item?.evaluation?.level_id,
          });
          const level = me.levels.find((x) => x.id == item?.evaluation?.level_id);
          me.bodyParts.forEach((x) => {
            if (x.id == item?.evaluation?.body_part_id) {
              x.isAdd = true;
              me.fillBodyPart(x?.code, level);
            }
          });
        })
      }
    },
  },
  computed: {
    isDisabled() {
      const me = this;
      return me.id ? true : false;
    },
  },
  validations: {
    formData: {
      seniority_company: {
        required,
      },
      seniority_position: {
        required,
      },
      turn: {
        required,
      },
      predominance: {
        required,
      },
      position_type: {
        required,
      },
      size: {
        required,
      },
      weight: {
        required,
      },
      corporal_index: {
        required,
      },
      interpretation: {
        required,
      },
      smoke: {
        required,
      },
      physical_activity: {
        required,
      },
      pain_of_body: {
        required,
      },
      musculoskeletal_disease: {
        required,
      },
      made_at: {
        required,
      },
      made_in: {
        required,
      },
      made_by: {
        required,
      },
    },
  },
  methods: {
    async loadEmployee() {
      const me = this;
      try {
        const { data } = await getEmployee(me.type);
        me.employee = data;
      } catch (error) {
        console.log(error);
      }
    },
    async loadMorbidityFrequency() {
      const me = this;
      try {
        const { data } = await getInfoSelect("morbidity_frequency");
        data.forEach((x) => {
          me.frecuencies.push({
            id: x.id,
            name: x.info,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async loadCities() {
      const me = this;
      try {
        const { data } = await getCities();
        me.cities = data;
      } catch (error) {
        console.log(error);
      }
    },
    async loadMorbidityLevel() {
      const me = this;
      try {
        const { data } = await getInfoSelect("morbidity_level");

        data.forEach((x) => {
          let color = "#DA1414";
          if (x.id == 18) {
            color = "#FFD97C";
          } else if (x.id == 19) {
            color = "#FF9900";
          }
          me.levels.push({
            id: x.id,
            name: x.info,
            color: color,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async loadBodyParts() {
      const me = this;
      me.isLoadingBodyParts = true;
      try {
        const { data } = await getAllBodyParts();
        data.forEach((x) => {
          me.bodyParts.push({
            ...x,
            isAdd: false,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoadingBodyParts = false;
      }
    },
    async saveData() {
      const me = this;
      try {
        if (!me.identifierFile && me.identifierEmail) {
          const { data } = await verifyAuthorization(me.identifierEmail);
          if (!data?.is_authorized) {
            me.$bvModal.show("modal-await-confirm-email");
            return;
          }
        }
        me.isBusy = true;
        const formData = {
          seniority_company: me.formData.seniority_company,
          seniority_position: me.formData.seniority_position,
          turn: me.formData.turn,
          predominance: me.formData.predominance?.id,
          position_type: me.formData.position_type?.id,
          size: me.formData.size?.id,
          weight: me.formData.weight,
          corporal_index: me.formData.corporal_index,
          interpretation: me.formData.interpretation,
          smoke: me.formData.smoke?.value,
          physical_activity: me.formData.physical_activity?.value,
          pain_of_body: me.formData.pain_of_body?.value,
          musculoskeletal_disease: me.formData.musculoskeletal_disease?.value,
          employee_id: me.type,
          body_parts: me.formData.body_parts,
          made_at: me.formData.made_at,
          made_in: me.formData.made_in?.id,
          made_by: me.formData.made_by,
          identifier: me.identifierFile || me.identifierEmail,
        };
        await saveMorbidity(formData);
        me.$emit("onSuccess");
      } catch (error) {
        console.log(error);
        me.$emit("onError");
      } finally {
        me.isBusy = false;
      }
    },
    addBodyParts(item) {
      const me = this;
      me.itemBodyPart = item;
      me.$bvModal.show("modal-add-body-part");
    },
    addBodyPartsConfirm(values) {
      const me = this;
      me.formData.body_parts.push({
        body_part_id: me.itemBodyPart?.id,
        frequency_id: values?.frequency?.id,
        level_id: values.level?.id,
      });
      me.bodyParts.forEach((x) => {
        if (x.id == me.itemBodyPart?.id) {
          x.isAdd = true;
          me.fillBodyPart(x?.code, values.level);
        }
      });
    },
    fillBodyPart(code, level) {
      const partElement = document.getElementById(`part_${code}`);
      if (partElement) {
        partElement.style.fill = level?.color;
      }
    },
    calcularTiempo(fechaInicio) {
      const fechaActual = this.$moment(); // Fecha actual
      const fechaInicioObj = this.$moment(fechaInicio, "YYYY-MM-DD");

      // Calcula la diferencia en años
      const años = fechaActual.diff(fechaInicioObj, "years");
      fechaInicioObj.add(años, "years"); // Ajusta la fecha de inicio al año actual

      // Calcula la diferencia en meses
      const meses = fechaActual.diff(fechaInicioObj, "months");
      fechaInicioObj.add(meses, "months"); // Ajusta la fecha de inicio al mes actual

      // Calcula la diferencia en días
      const dias = fechaActual.diff(fechaInicioObj, "days");

      return `${años} años, ${meses} meses y ${dias} días`;
    },
    sendEmail() {
      const me = this;
      me.$bvModal.show("modal-request-confirm-email");
    },
    downloadAuthorization() {
      const me = this;
      let link = `${process.env.VUE_APP_URL_API}/v2/health-tracker/health-conditions/felt-authorization/${me.formData.made_by}`;
      const a = document.createElement("a");
      a.href = link;
      a.target = "_blank";
      a.click();
    },
    sendEmailSuccess(data) {
      const me = this;
      me.identifierEmail = data?.identifier;
    },
    successFileAuthorization(value) {
      const me = this;
      me.identifierFile = value;
    },
    selectPart(code) {
      const me = this;
      if (!me.record) {
        const record = me.bodyParts.find((x) => x.code == code);
        const record2 = me.formData.body_parts.find(
          (x) => x.body_part_id == record?.id
        )
        if (!record2 && record) me.addBodyParts(record);
      }
    },
  },
  mounted() {
    const me = this;
    me.loadEmployee();
    me.loadMorbidityFrequency();
    me.loadMorbidityLevel();
    me.loadBodyParts();
    me.loadCities();
  },
};
</script>

<style lang="css">
.content-form-examen {
  border: 1px solid #cfd8dc;
  padding: 12px;
  border-radius: 8px;
  text-align: left !important;
}
.content-form-examen .header {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 40px;
  background-color: #eceff1 !important;
  padding-left: 10px;
}
.card-form-survey {
  border: 1px solid #7a7cff;
  border-radius: 16px;
  padding: 24px;
}
.card-form-survey h3 {
  color: #546e7a !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  margin-bottom: 0 !important;
}
.card-form-survey .title-form-survey {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 400 !important;
}
.card-form-survey-2 {
  border: 1px solid #0075ff !important;
  border-radius: 4px;
  padding: 10px;
}
.card-form-survey-alert {
  border: 1px solid #0075ff;
  border-radius: 4px;
  padding: 4px;
  background-color: #e6f7ff;
}
.card-list-body-survey {
  border: 1px solid #cfd8dc;
  border-radius: 12px;
  height: 600px;
  border-radius: 8px;
  padding: 10px;
  overflow-y: auto;
}
.card-list-body-survey .content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #eceff1;
  padding: 8px;
  border-radius: 8px;
  height: 36px;
}
.card-list-body-survey .content-item span {
  font-size: 16px;
  color: #546e7a;
  font-weight: 500;
}
.card-list-body-survey .content-item button {
  display: flex;
  justify-content: center;
  gap: 5px;
  align-items: center;
  border: none;
  color: #5d5fef;
  font-weight: 600;
  font-size: 16px;
}
.card-list-body-survey .content-item .active {
  display: flex;
  justify-content: center;
  gap: 5px;
  align-items: center;
  border: none;
  color: #0c9e42;
  font-weight: 600;
  font-size: 16px;
}
.content-buttons-survey button {
  border: 1px solid #5d5fef;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #5d5fef;
  background-color: white;
}
</style>
